import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ADMIN, Constants } from '@co-assist/library';

@Component({
    selector: 'app-catalog',
    templateUrl: './catalog.component.html',
    styleUrls: ['./catalog.component.scss'],
    standalone: false
})
export class CatalogComponent implements OnInit {
    private translate = inject(TranslateService);


    readonly DISPLAY_FILTER_THRESHOLD = 2;
    readonly B2B_BUSINESS = ADMIN.BUSINESS_TYPE.B2B;
    // Give the display order of the devices in the catalog
    readonly DEVICE_TYPES: Array<Constants.Entity.DeviceType> = [
        Constants.Entity.DeviceType.CALWB,
        Constants.Entity.DeviceType.CAW
    ];

    selectAll: boolean = true;
    allFieldsView: string;

    deviceFormControl: UntypedFormControl = new UntypedFormControl(this.DEVICE_TYPES);

    ngOnInit(): void {
        this.deviceFormControl.valueChanges.subscribe(value => this.selectAll = value.length === this.DEVICE_TYPES.length);
    }

    select(): void {
        this.selectAll = !this.selectAll;
        this.deviceFormControl.setValue(this.selectAll ? this.DEVICE_TYPES : []);
    }

    getSelectTriggerDisplay(): string {
        let display: string;
        const filteredDevices: Array<Constants.Entity.DeviceType> = this.deviceFormControl.value;
        if (this.selectAll) {
            display = this.translate.instant('CATALOG.FILTER_ALL');
        } else if (filteredDevices) {
            display = filteredDevices
                .slice(0, this.DISPLAY_FILTER_THRESHOLD)
                .map(device => this.translate.instant(`DEVICE_TYPE.${device}`))
                .join(', ');
            if (filteredDevices.length > this.DISPLAY_FILTER_THRESHOLD) {
                display += this.translate.instant('CATALOG.FILTER_VALUE', { counter: filteredDevices.length - this.DISPLAY_FILTER_THRESHOLD });
            }
        }
        return display;
    }

}
